export const ADMIN_TOKEN_STORAGE_KEY = 'afrovate_admin_token';

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_STORAGE_KEY) || '';

export const setAdminToken = (token) => {
  localStorage.setItem(ADMIN_TOKEN_STORAGE_KEY, token);
};

export const clearAdminToken = () => {
  localStorage.removeItem(ADMIN_TOKEN_STORAGE_KEY);
};
